import { Checkbox, TableCell, TableRow } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import type { IGenericUploadPhoneConflict } from "../../../generic-upload.models";
import {
  formatPhoneConflictDetails,
  formatPhoneConflictPassengerLabel,
} from "../../../helpers";

interface IPhoneConflictsTableRowProps {
  conflict: IGenericUploadPhoneConflict;
  isSkipped: boolean;
  onToggleSkippedRow: (dataIndex: number) => void;
}

export const PhoneConflictsTableRow: FC<IPhoneConflictsTableRowProps> = ({
  conflict,
  isSkipped,
  onToggleSkippedRow,
}) => {
  const { t } = useTranslation();

  const handleToggle = useEvent((): void => {
    onToggleSkippedRow(conflict.dataIndex);
  });

  return (
    <TableRow>
      <TableCell padding="checkbox">
        <Checkbox
          checked={isSkipped}
          onChange={handleToggle}
          slotProps={{
            input: {
              // ARIA attribute names are hyphenated by the spec.
              // eslint-disable-next-line @typescript-eslint/naming-convention
              "aria-label": t("genericUpload.phoneConflicts.skipRowAria", {
                index: conflict.index,
              }),
            },
          }}
        />
      </TableCell>
      <TableCell>{conflict.index}</TableCell>
      <TableCell>
        {formatPhoneConflictPassengerLabel(conflict.rowLabel)}
      </TableCell>
      <TableCell>{conflict.fieldValue || "-"}</TableCell>
      <TableCell>{formatPhoneConflictDetails(conflict, t)}</TableCell>
    </TableRow>
  );
};
